import { render, staticRenderFns } from "./DownloadXlsx.vue?vue&type=template&id=014a01a0"
import script from "./DownloadXlsx.vue?vue&type=script&lang=js"
export * from "./DownloadXlsx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports